import React, {useEffect, useState} from 'react'
import Header from "../components/Header"
import BreadCrumbs from "../components/BreadCrumbs"
import Notification from "../components/Notification"
import {apiChangePassword, apiMy} from "api-methods"
import '../css/EditCompany.css'
import {useLocation, useNavigate} from "react-router-dom"
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const ChangePasswordForm = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const [formData, setFormData] = useState({
        password: '',
        passwordCheck: '',
        sendEmail: false
    })
    const [showPassword, setShowPassword] = useState(false)
    const [notification, setNotification] = useState(null)

    useEffect(() => {
        apiMy()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
            })
            .catch(_ => {})
    }, [])

    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}
    const handleInputChange = (e) => {const { name, value, type, checked } = e.target;setFormData(prev => ({...prev, [name]: type === 'checkbox' ? checked : value}))}

    const validatePassword = (password) => {
        const allowedChars = /^[A-Za-z0-9!@#$%^&*-]+$/
        if (password.length < 8) {
            return 'Пароль должен содержать минимум 8 символов'
        }
        if (!allowedChars.test(password)) {
            return 'Пароль может содержать только a-z, A-Z, 0-9 и !@#$%^&*-'
        }
        if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password) || !/[!@#$%^&*-]/.test(password)) {
            return 'Пароль должен содержать a-z, A-Z, 0-9 и !@#$%^&*-'
        }
        return ''
    }

    const handleSave = () => {
        const passwordError = validatePassword(formData.password)
        const repeatNewPassword = showPassword ? formData.password : formData.passwordCheck
        if (passwordError) {
            showNotification(passwordError, 'error')
        } else if (formData.password !== repeatNewPassword) {
            showNotification('Пароли не совпадают', 'error')
        } else {
            apiChangePassword({
                newPassword: formData.password,
                repeatNewPassword,
                sendToMail: formData.sendEmail
            })
                .then(data => {
                    if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                    if (isSuccessStatus(data.code)) {showNotification('Данные успешно сохранены!', 'success')} else {showNotification('Ошибка сохранения', 'error')}
                })
                .catch(_ => {showNotification('Ошибка сохранения', 'error')})
        }
    }

    return <div className="pageChangePassword">
        <Header/>
        <BreadCrumbs title={'Данные пользователя → Сменить пароль'}/>
        <div className="pagePersonalContent">
            <div className="user-form-container">
                <div className="form-grid1">
                    <div className="form-column">

                        <div className="form-field">
                            <label>Новый пароль*</label>
                            <div className="password-input-wrapper">
                                <input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleInputChange} placeholder="Не указано"/>
                                <button type="button" className={`password-toggle ${showPassword ? 'active' : ''}`} onClick={() => setShowPassword(prev => !prev)} aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'} title={showPassword ? 'Скрыть пароль' : 'Показать пароль'} />
                            </div>
                        </div>

                        {!showPassword && (
                            <div className="form-field">
                                <label>Повторите пароль*</label>
                                <div><input type="password" name="passwordCheck" value={formData.passwordCheck} onChange={handleInputChange} placeholder="Не указано"/></div>
                            </div>
                        )}

                        <div className="form-field">
                            <label className="checkbox-label">
                                <input type="checkbox" name="sendEmail" checked={formData.sendEmail} onChange={handleInputChange}/>
                                <span>Отправить на E-mail</span>
                            </label>
                        </div>

                    </div>
                </div>

                {/* Кнопки */}
                <div className="allPagesStyleButton-posLeft">
                    <div className="allPagesStyleButton-group">
                        <div className="allPagesStyleButton" onClick={handleSave}>Сохранить</div>
                    </div>
                </div>

                {/* Уведомление */}
                {notification && (<Notification message={notification.message} type={notification.type} onClose={hideNotification} duration={3000}/>)}
            </div>
        </div>
    </div>
}

export default ChangePasswordForm

